import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  ModalBody,
  Carousel,
  CarouselItem,
  CarouselControl,
  Card,
  CardImg,
  CardTitle,
  CardBody,
} from "reactstrap";
import { MultiSelect } from "react-multi-select-component";
import { useDispatch, useSelector } from "react-redux";
import {
  getGymCategories,
  getProducts,
} from "../../redux/actions/api/apiAction";
import {
  setProductsLimit,
  setProductsPage,
} from "../../redux/actions/product/productAction";
import { BarcodeScannerPopup } from "./scanBarcodePopUp";
import { toastr } from "react-redux-toastr";
import { ComonIcons } from "../../contents/commonIcons";
import SpinnerComponent from "../spinner/spinner";

const ProductComponentV2 = ({
  setSingleProduct,
  selectedProducts,
  handleProductChange,
  setToDeleteProduct,
  tax,
  singleProductTouched,
  setSelectedSaleServices,
  selectedPackages,
  setShowProductDialog,
}) => {
  const {
    availableProducts,
    productsLimit,
    productsPage,
    searchBarcode,
    productsCount,
    isProductsLoading,
  } = useSelector((state) => state.product);
  const { gym, categories } = useSelector((state) => state.gym);

  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [price, setPrice] = useState(null);

  const [barcodeModal, setBarcodeModal] = useState("");
  const [priceWithTax, setPriceWithTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [isCarouselLoading, setIsCarouselLoading] = useState(false);
  const [quantity,setQuantity]=useState("")
  const handleSubmit = () => {
    setShowProductDialog(false);
    setSelectedSaleServices([]);
  };

  const onExiting = () => setAnimating(true);

  const onExited = () => setAnimating(false);

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );
  };

  const handlePageChange = (page) => {
    dispatch(setProductsPage(page));
  };

  const previous = () => {
    if (animating || productsPage <= 1) return;
    setActiveIndex((activeIndex - 1 + items.length) % items.length);
    handlePageChange(productsPage - 1);
    setIsCarouselLoading(true);
  };

  const next = () => {
    if (animating || productsPage >= Math.ceil(productsCount / productsLimit))
      return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
    dispatch(setProductsPage(productsPage + 1));
    setIsCarouselLoading(true);
  };
  const addToCart = (product) => {
    setSingleProduct(product);
    const totalPending = product?.pendingTransfers.reduce(
    (sum, p) => sum + p.pendingQuantity,
    0
   );
    let maxQuantity = product.availableInStock;
    if (product?.quantity) {
      if (product.quantity + 1 > maxQuantity) {
       toastr.error(" Available in stock is " + maxQuantity);
         product.quantity = maxQuantity;

      } else if(product.quantity + 1 > (maxQuantity - totalPending)){
        toastr.error(" Available in stock after pending transfers is " + (maxQuantity - totalPending));
        product.quantity = maxQuantity - totalPending;
      }
      else {
        product.quantity = product.quantity + 1;
      }
    } else {
      product.quantity = 1;
    }
    handleProductChange(product, product?.quantity);
  };
  useEffect(() => {
    if (selectedCategories.length) {
      dispatch(
        getProducts({
          limit: productsLimit,
          page: 1,
          category: selectedCategories.map((el) => el.value).join(","),
          available: true,
        })
      );
    }
  }, [selectedCategories.length]);

  useEffect(() => {
    dispatch(setProductsLimit(3));
    dispatch(getGymCategories());
  }, []);

  useEffect(() => {
    setItems(chunkArray(availableProducts, 3));
    setIsCarouselLoading(false);
  }, [availableProducts]);

  useEffect(() => {
    dispatch(
      getProducts({
        limit: productsLimit == 10 ? 3 : productsLimit,
        page: productsPage,
        available: true,
        search: search && search,
        searchBarcode: searchBarcode && searchBarcode,
        price: price && price,
      })
    );
  }, [productsPage, productsLimit, search, searchBarcode, price]);

  useEffect(() => {
    handlePageChange(1);
  }, [search, searchBarcode, selectedCategories, price]);

  useEffect(() => {
    let sum, discount, totalWithTax, totalWithTaxRounded;
    switch (selectedPackages.length) {
      case 0: {
        sum = 0;
        discount = 0;
        totalWithTax = 0.0;
        break;
      }
      case 1: {
        sum = selectedPackages[0].price / (1 + (tax || 0) / 100);
        discount = (sum * selectedPackages[0].discount) / 100 || 0;
        totalWithTax = (sum - discount) * (1 + (tax || 0) / 100);
        totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        break;
      }
      default: {
        let discountArr = selectedPackages.map(
          (pack) =>
            (pack.price / (1 + (tax || 0) / 100)) * (pack.discount / 100 || 0)
        );
        let pricesArr = selectedPackages.map((pack) => pack.price);
        let sum1 = pricesArr.reduce((a, b) => a + b);
        sum = sum1 / (1 + (tax || 0) / 100);
        discount = discountArr.reduce((a, b) => a + b);
        totalWithTax = ((sum - discount) * (1 + (tax || 0) / 100)).toFixed(2);
        totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        break;
      }
    }

    switch (selectedProducts.length) {
      case 1: {
        sum =
          sum +
          (selectedProducts[0].price *
            (selectedProducts[0].quantity ? selectedProducts[0].quantity : 0)) /
            (1 + (tax || 0) / 100);
        totalWithTax = (sum - discount) * (1 + (tax || 0) / 100);
        totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(2);
        break;
      }
      default: {
        if (selectedProducts.length > 0) {
          let discountArr = selectedProducts.map(
            (pack) =>
              ((pack.price * (pack.quantity || 0)) / (1 + (tax || 0) / 100)) *
              (pack?.discount / 100 || 0)
          );
          let pricesArr = selectedProducts.map((pack) => {
            return {
              price: pack.price,
              quantity: pack.quantity ? pack.quantity : 0,
            };
          });
          let sum1 = pricesArr.reduce(
            (a, b) => a + b.price * b.quantity,
            0 // Starting with an initial value of 0
          );

          sum = sum + sum1 / (1 + (tax || 0) / 100);
          discount = discountArr.reduce((a, b) => a + b);
          totalWithTax = ((sum - discount) * (1 + (tax || 0) / 100)).toFixed(2);
          totalWithTaxRounded = (Math.round(totalWithTax * 100) / 100).toFixed(
            2
          );
          break;
        }
      }
    }

    setTotalPrice(sum);
    // setTotalDiscount(discount.toFixed(2));
    setPriceWithTax(totalWithTaxRounded);
  }, [selectedProducts, singleProductTouched, selectedPackages]);

  return (
    <ModalBody>
      <div>
        <div className="add-trainer-popup adding-popup bg-white card-panel">
          <div className="basic-info">
            <div className="info-title with-border">
              <div className="">
                <h4 className={`product-pop-up assign-product `}>
                  Assign Product to Member{" "}
                  <span className={`h5 assign-product-sub-title`}>
                    Add info to product
                  </span>
                </h4>
              </div>
            </div>
            <Formik enableReinitialize initialValues={{}}>
              {({}) => (
                <Form>
                  <Row>
                    <Col md={12}>
                      <Row>
                        <Col md={4} style={{ marginTop: "26px" }} xs={12}>
                          <p className="product-pop-up label-txt mb-2">
                            Category
                          </p>
                          <MultiSelect
                            options={
                              categories
                                ? categories.map((el) => {
                                    return { label: el, value: el };
                                  })
                                : []
                            }
                            value={selectedCategories}
                            onChange={(e) => {
                              // when user choose a category will call api to get products filtered by category
                              setSelectedCategories(e);
                            }}
                            label="Select Category"
                            closeOnChangedValue={true}
                          />
                        </Col>
                        <Col
                          md={4}
                          style={{
                            marginTop: "26px",
                          }}
                          xs={9}
                        >
                          <p className="product-pop-up label-txt mb-2">
                            Search by name
                          </p>
                          <Input
                            className={`form-control form-control d-flex align-items-center`}
                            type="text"
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                              height: "63%",
                            }}
                          />
                        </Col>
                        <Col md={2} style={{ marginTop: "26px" }} xs={12}>
                          <p className="product-pop-up label-txt mb-2">Price</p>
                          <Input
                            className={`form-control form-control d-flex align-items-center`}
                            type="text"
                            onChange={(e) => setPrice(e.target.value)}
                            style={{
                              height: "63%",
                            }}
                          />
                        </Col>
                        <Col
                          md={2}
                          xs={2}
                          style={{
                            marginTop: "57px",
                            // height: "51px !important",
                          }}
                        >
                          <div
                            onClick={() => setBarcodeModal(true)}
                            style={{ cursor: "pointer" }}
                            className="product-pop-up barcode-box"
                          >
                            <p>{ComonIcons.scanner}</p>
                          </div>
                        </Col>

                        {barcodeModal && (
                          <BarcodeScannerPopup
                            barcodeModal={barcodeModal}
                            toggle={setBarcodeModal}
                          />
                        )}
                      </Row>
                    </Col>
                    {isProductsLoading && !isCarouselLoading ? (
                      <Col md={12}>
                        <div className="d-flex flex-column align-items-center justify-content-center h-50 mt-5">
                          <SpinnerComponent />
                          <h3>Please wait</h3>
                        </div>
                      </Col>
                    ) : availableProducts.length ? (
                      <Col md={12} className="mt-3">
                        <p className="product-pop-up select-product-text mb-2">
                          {`Select Products ( ${productsCount} Products )`}
                        </p>
                        {isCarouselLoading ? (
                          <Row className="justify-content-center">
                            {[...Array(3)].map((_, i) => (
                              <Col md="4" key={i}>
                                <Card className="d-flex flex-column text-center product-pop-up product-card">
                                  <div className="skeleton skeleton-img mx-auto"></div>
                                  <div className="mx-auto skeleton skeleton-text"></div>
                                  <div className="mx-auto skeleton skeleton-price"></div>
                                  <div
                                    className="mx-auto mt-2 skeleton skeleton-text"
                                    style={{ width: "60%" }}
                                  ></div>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <Carousel
                            activeIndex={activeIndex}
                            next={next}
                            previous={previous}
                            interval={false} // 👈
                            className="product_carousel"
                            fade={false}
                          >
                            {items.map((group, idx) => (
                              <CarouselItem
                                key={idx}
                                onExiting={onExiting}
                                onExited={onExited}
                              >
                                <Row className="justify-content-center">
                                  {group.map((product) => (
                                    <Col md="4" key={product.id}>
                                    <Card className="d-flex flex-column text-center product-pop-up product-card h-100">
                                      {/* Product image */}
                                      {product?.image ? (
                                        <CardImg
                                          src={product?.image}
                                          alt={ComonIcons.img}
                                          className="product-pop-up product-card product-img mx-auto"
                                        />
                                      ) : (
                                        <div className="product-pop-up product-card product-img mx-auto">
                                          {ComonIcons.img}
                                        </div>
                                      )}

                                      {/* Title + Price */}
                                      <CardBody className="d-flex flex-column">
                                        <CardTitle
                                          tag="h5"
                                          className="product-pop-up title"
                                          title={product?.name}
                                        >
                                          {product?.name?.length > 20
                                            ? product.name.slice(0, 20) + "…"
                                            : product.name}
                                        </CardTitle>
                                        <p className="product-pop-up price">
                                          {product?.price}{" "}
                                          {
                                            JSON.parse(
                                              localStorage.getItem("connectToFitGymPanelUser")
                                            )?.currency
                                          }
                                        </p>

                                        {/* Spacer pushes footer to bottom */}
                                        <div className="flex-grow-1"></div>

                                        {/* Footer: Quantity + Button always at bottom */}
                                        <div className="d-flex flex-column align-items-center mt-2">
                                          {selectedProducts.find((pr) => pr.id == product.id)?.quantity ? (
                                            <div className="d-flex align-items-center justify-content-center ">
                                              <button
                                                size="sm"
                                                className="product-pop-up product-card quantity-btn"
                                                onClick={() => {
                                                  let selectedProduct = selectedProducts.find(
                                                    (pr) => pr.id == product.id
                                                  );
                                                  if (selectedProduct?.quantity > 1) {
                                                    selectedProduct.quantity = selectedProduct.quantity - 1;
                                                    handleProductChange(
                                                      selectedProduct,
                                                      selectedProduct?.quantity
                                                    );
                                                  } else {
                                                    setToDeleteProduct(selectedProduct.id);
                                                  }
                                                }}
                                              >
                                                –
                                              </button>

                                              <input
                                                type="number"
                                                min="1"
                                                max={product.availableInStock} // 👈 prevent typing beyond stock
                                                value={selectedProducts.find((pr) => pr.id == product.id)?.quantity !==1?selectedProducts.find((pr) => pr.id == product.id)?.quantity:quantity }
                                                onChange={(e) => {
                                                  let val = e.target.value;
                                                  console.log({val,product})
                                                  let newQty = parseInt(val); 
                                                  setQuantity(newQty)     
                                                      const totalPending = product?.pendingTransfers.reduce(
                                                        (sum, p) => sum + p.pendingQuantity,
                                                        0
                                                      );                       
                                                  if(!isNaN(newQty) && newQty > 0 && newQty){
                                                    if(newQty > product.availableInStock){
                                                        newQty = product.availableInStock; // cap at stock
                                                       toastr.error(`Only ${product.availableInStock} in stock.`);
                                                    }
                                                    else if(newQty > (product.availableInStock - totalPending)){
                                                        toastr.error(" Available in stock after pending transfers is " + (product.availableInStock - totalPending));
                                                       newQty = product.availableInStock - totalPending;
                                                      }
                                                  }else{
                                                    newQty=1
                                                  }
                                                    let selectedProduct = selectedProducts.find(
                                                      (pr) => pr.id == product.id
                                                      );
                                                    selectedProduct.quantity=newQty
                                                    handleProductChange(selectedProduct, selectedProduct?.quantity);
                                                }}
                                                className="quantity-input mx-2"
                                                style={{
                                                  width: "60px",
                                                  textAlign: "center",
                                                  border: "1px solid #ddd",
                                                  borderRadius: "6px",
                                                  fontSize: "14px",
                                                }}
                                              />

                                              <button
                                                size="sm"
                                                className="product-pop-up product-card quantity-btn"
                                                onClick={() => {
                                                  let selectedProduct = selectedProducts.find(
                                                    (pr) => pr.id == product.id
                                                  );
                                                  addToCart(selectedProduct);
                                                }}
                                               type="button"   
 
                                              >
                                                +
                                              </button>
                                            </div>
                                          ) : null}

                                          {/* Add to cart button */}
                                          <button
                                            className={`product-pop-up product-card ${
                                              selectedProducts.find((pr) => pr.id == product.id)?.quantity
                                                ? "added-to-cart-btn"
                                                : "add-to-cart-btn"
                                            } btn-text mb-2`}
                                            onClick={() =>  {setQuantity("")
                                              addToCart(product)}}
                                           type="button"   
                                          >
                                            {selectedProducts.find((pr) => pr.id == product.id)?.quantity
                                              ? `${
                                                  selectedProducts.find((pr) => pr.id == product.id)?.quantity
                                                } Quantity Added`
                                              : "+ Add Product"}
                                          </button>
                                        </div>
                                      </CardBody>
                                    </Card>

                                    </Col>
                                  ))}
                                </Row>
                              </CarouselItem>
                            ))}
                            <CarouselControl
                              direction="prev"
                              directionText="Previous"
                              onClickHandler={previous}
                            />

                            <CarouselControl
                              direction="next"
                              directionText="Next"
                              onClickHandler={next}
                            />
                          </Carousel>
                        )}
                      </Col>
                    ) : (
                      <div className="d-flex flex-column align-items-center justify-content-center h-50 mt-5 col-md-12">
                        <h3 style={{ textAlign: "center" }}>
                          There Are no Available Products
                        </h3>
                      </div>
                    )}

                    <Col
                      className="mt-3 info-title with-border"
                      md={12}
                      lg={12}
                      xs={12}
                    >
                      <div className="d-flex justify-content-center with-border">
                        <Row xs={12} className="sale-summary">
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="summary-item-sigle-container"
                          >
                            <span className="item-text">
                              Selected Products :{" "}
                            </span>
                            <span>{selectedProducts.length} Products</span>
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className="summary-item-sigle-container"
                          >
                            <span className="item-text">Total Price :</span>
                            <span>
                              {priceWithTax?.toLocaleString() || 0}{" "}
                              {
                                JSON.parse(
                                  localStorage.getItem(
                                    "connectToFitGymPanelUser"
                                  )
                                ).currency
                              }
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Row className="mt-3 action-btn-product-div">
                      <Col xs="6" md={6} lg={6}>
                        <div className="">
                          <Button
                            style={{
                              backgroundColor: "transparent",
                              color: "black",
                            }}
                            onClick={() => {
                              setSelectedSaleServices([]);
                              setShowProductDialog(false);
                              let arr = [...selectedProducts];
                              arr.map((el) => {
                                setToDeleteProduct(el.id);
                              });
                            }}
                            className="add-sale-submit-btn"
                          >
                            Cancel
                          </Button>
                        </div>
                      </Col>
                      <Col xs="6" md={6} lg={6}>
                        <div className="text-right ">
                          <Button
                            style={{ backgroundColor: "#475569" }}
                            onClick={handleSubmit}
                            className="add-sale-submit-btn"
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </ModalBody>
  );
};

export default ProductComponentV2;
